module.exports = __webpack_public_path__ + "img/twitch.f0f35bb1.png";